import { render, staticRenderFns } from "./editCubeRichText.vue?vue&type=template&id=4311b04e&scoped=true&"
import script from "./editCubeRichText.vue?vue&type=script&lang=js&"
export * from "./editCubeRichText.vue?vue&type=script&lang=js&"
import style0 from "./editCubeRichText.vue?vue&type=style&index=0&id=4311b04e&prod&lang=scss&"
import style1 from "./editCubeRichText.vue?vue&type=style&index=1&id=4311b04e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4311b04e",
  null
  
)

export default component.exports